import {DrawerProps} from '@mantine/core';
import {PlatformDrawer} from '@flexinet/ui-components';
import {RecordForm} from '../forms/RecordForm';
import {Price} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Price,
        handleSubmit: (values: Price) => void
    }) => {

    const title = record?.id ? 'Edit Price' : 'Add Price';

    const handleFormSubmit = async (values: Price) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            size="xl"
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    );
};
